import httpClient from '@frontend-monorepo/http-client';

const sendInviteToken = async (token: string) => {
  await httpClient.get(`/v1/invited_user?token=${token}`);
};

export default {
  sendInviteToken,
};
